import { InExpression } from "./expressions/InExpression.ts";
import { PropertyExpression } from "./expressions/PropertyExpression.ts";
import { escapeSingleQuotes } from "./odata-string-utils.ts";

interface IdFilterOptions {
    quoted?: boolean;
}

export function buildInFilter(property: string, values: (string | number)[]): string | undefined {
    if (values.length === 0) {
        return undefined;
    }

    return new InExpression(new PropertyExpression(property), values).stringify();
}

function joinIds(values: (string | number)[], { quoted = false }: IdFilterOptions) {
    return values.map(value => (quoted ? `'${escapeSingleQuotes(String(value))}'` : value)).join(",");
}

export function buildIdInFilter(
    property: string,
    values: (string | number)[],
    options: IdFilterOptions = {}
): string | undefined {
    if (values.length === 0) {
        return undefined;
    }

    return `${property} in (${joinIds(values, options)})`;
}

export function buildIdNotInFilter(
    property: string,
    values: (string | number)[],
    options: IdFilterOptions = {}
): string | undefined {
    if (values.length === 0) {
        return undefined;
    }

    return `not (${property} in (${joinIds(values, options)}))`;
}
